import { Box, Button } from '@mui/material'
import {
    GridColumnsManagement,
    useGridApiContext,
    type GridColumnsManagementProps,
} from '@mui/x-data-grid-pro'
import { type FC } from 'react'

export const ColumnsManagementWithShowAll: FC<GridColumnsManagementProps> = (
    props
) => {
    const apiRef = useGridApiContext()

    const handleShowAll = () => {
        apiRef.current.setColumnVisibilityModel({
            rosterCandidateFavoriteCount: false,
        })
    }

    return (
        <Box>
            <GridColumnsManagement
                {...props}
                disableResetButton
                disableShowHideToggle
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    px: 1,
                    pb: 1,
                }}
            >
                <Button
                    size="small"
                    onClick={handleShowAll}
                    sx={{
                        fontSize: '0.6875rem',
                        textTransform: 'none',
                        py: 0.5,
                        px: 1,
                        minWidth: 'auto',
                    }}
                >
                    Reset
                </Button>
            </Box>
        </Box>
    )
}
